import Page from 'components/pages/join-us'
import initRequest from 'request/join-us/init'

export async function getStaticProps() {
  let { studioPerformance, studios } = await initRequest()
  studios = studios
    .filter(({ contract }) => contract?.isRecruiting)
    .map(studio => {
      let recruitStatus = '徵才中'
      let btnText = '申請加入'
      if (studio.contract?.isFull) {
        recruitStatus = '已額滿'
        btnText = '我想候補'
      }
      return { ...studio, $recruitStatus: recruitStatus, $btnText: btnText }
    })
    .sortBy(studio => !studio.contract?.isFull)

  return { props: { studios, studioPerformance }, revalidate: 60 * 60 }
}

export default function JoinUs(initData) {
  const t = useI18n()
  const title = t.seo.title('custom', { value: '加入美配特約店，看見另一種職涯可能' })
  const description = '不畫餅造夢，一加入就很有感覺，收入很高但協助很多，讓你不用下廣告也能穩定獲得新客，如果你是業績穩定的資深設計師或店家經營者，還可透過經驗傳承發展團隊，創造穩定的被動收入！'
  const image = {
    url: cdn('next/referral-code/sinliya.jpg'),
    width: 1200,
    height: 628
  }

  return (
    <>
      <C.Head>
        { h.seo({ title, description }) }
        { h.og({ image }) }
      </C.Head>
      <Page initData={ initData }/>
    </>
  )
}
